module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="container-full">\n	<div class="coming-soon">\n    	<div class="text-block">\n    		<p>\n				Quick Trading is now available in My Team! Just press T on your player to choose a trade for them. If you\'re looking to undertake more complex trades, like two at a time or dual-position switches, please download the NRL Fantasy app, or head to the NRL Fantasy website on a desktop computer.\n			</p>\n    	</div>\n    </div>\n</div>';
}
return __p;
};
